export const AUTH_CONFIG = {
  domain: "metricstory.auth0.com",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  callbackUrl:
    window.location.origin + process.env.REACT_APP_AUTH0_CALLBACK_PATH
};
